module["exports"] = [
  "España"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/default_country.js
// module id = 1227
// module chunks = 1